import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
} from "@mui/material";
import { UpdateOrdersReportInfo } from "../../services/OrderService";
import CommonLoader from "../common/CommonLoader";
import { NotificationManager } from "react-notifications";
const EditOrderReporting = ({ order, onSave, onClose, open }) => {
  const [formData, setFormData] = useState({
    orderNumber: order?.orderNumber || "",
    reportingName: order?.reportingName || "",
    reportContact: order?.reportContact || "",
    reportAddress: order?.reportAddress || "",
    reportAddress2: order?.reportAddress2 || "",
    reportCity: order?.reportCity || "",
    reportState: order?.reportState || "",
    reportZip: order?.reportZip || "",
    reportPhone: order?.reportPhone || "",
    reportFax: order?.reportFax || "",
    reportEmail: order?.reportEmail || "",
  });
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    if (onSave) {
        handleUpdateCall(formData);
    }
  };

  const handleUpdateCall = async (orderReportData) => {
    try {
      let response;
      setLoading(true);

      response = await UpdateOrdersReportInfo(orderReportData);

      if (response.status === 200) {
        NotificationManager.success(
          "Order Report Information updated successfully"
        );
        onClose();
        window.location.reload(false);
      } else {
        NotificationManager.error("Error updating Order Report Information");
      }
    } catch (error) {
      NotificationManager.error("Error updating Order Report Information");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Reporting Details</DialogTitle>
      <DialogContent>
        {loading && <CommonLoader loading={loading} />}
        <Typography variant="h6" sx={{ mb: 2 }}>
          Orders : {order?.orderNumber || ""}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Reporting Name"
              name="reportingName"
              value={formData.reportingName}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Contact"
              name="reportContact"
              value={formData.reportContact}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Address"
              name="reportAddress"
              value={formData.reportAddress}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Address 2"
              name="reportAddress2"
              value={formData.reportAddress2}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report City"
              name="reportCity"
              value={formData.reportCity}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report State"
              name="reportState"
              value={formData.reportState}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Zip"
              name="reportZip"
              value={formData.reportZip}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Phone"
              name="reportPhone"
              value={formData.reportPhone}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Fax"
              name="reportFax"
              value={formData.reportFax}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Report Email"
              name="reportEmail"
              value={formData.reportEmail}
              onChange={handleChange}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditOrderReporting;
